export default [
  "You are so fucking pathetic",
  "Cunt",
  "Slut",
  "Pervert",
  "I bet you are a virgin",
  "You are empty inside",
  "I will ruin you",
  "Loser",
  "Your mouth is my toilet",
  "Everybody hates you",
  "You are a waste of time",
  "Pig",
  "Asshole",
  "I will make you cry like a baby",
  "Fuck you",
  "You are too ugly to go out in public",
  "Fuckface",
  "You deserve to be slapped in the face",
  "Imbecile",
]


// WEBPACK FOOTER //
// ./src/components/Insults/messages.js